import CoreAPI from "../coreAPI";
import User, { UserAPIResponse } from "../../classes/employerDashboard/user";
import OnboardingDetails from "../../classes/employerDashboard/onboardingDetails";
import APICompany from "./APICompany";
import APIPlan from "./APIPlan";
import APILaunchDetails from "./APILaunchDetails";
import APITeam from "./APITeam";
import { StaticDataList } from "../b2c/APIUser";
import { ScheduledPhoneCall } from "../../classes/common/calendly";

export default function APIUser(coreAPI: CoreAPI) {
  return {
    async removeUser(tenantId: number) {
      return coreAPI.authCall({
        method: "DELETE",
        endpoint: `/tenant/${tenantId}`,
      });
    },
    async getUser() {
      const apiCompany = APICompany(coreAPI);
      const [company, userDetails] = await Promise.all([
        apiCompany.getCompanyDetails(),
        coreAPI.authCall<UserAPIResponse>({
          endpoint: "/userDetails",
        }),
      ]);
      return User.fromAPI({
        ...userDetails,
        companyName: company?.companyName || "",
      });
    },
    async updateUser(userDetails: User) {
      const response = await coreAPI.authCall<UserAPIResponse>({
        method: "PATCH",
        endpoint: `/userDetails/${userDetails.userDetailsId}`,
        body: userDetails.toJSONForAPI(),
      });
      return User.fromAPI(response);
    },
    async getPayrollProviders() {
      return ["Gusto", "BambooHR", "Zenefits", "Namely", "Rippling", "ADP", "Workday"].sort();
    },
    async getOnboardingStatus() {
      const companyAPI = APICompany(coreAPI);
      const planAPI = APIPlan(coreAPI);
      const launchDetailsAPI = APILaunchDetails(coreAPI);
      const teamAPI = APITeam(coreAPI);
      const [companyDetails, plans, planAdminDetails, launchDetails, teamDetails, scheduledPhoneCall] =
        await Promise.all([
          companyAPI.getCompanyDetails(),
          planAPI.getAllPlans(),
          planAPI.getPlanAdministrator(),
          launchDetailsAPI.getLaunchDetails(),
          teamAPI.getMembers(),
          this.getScheduleCallDetails(),
        ]);
      return new OnboardingDetails({
        companyDetails,
        plans,
        planAdminDetails,
        launchDetails,
        teamMembers: teamDetails,
        scheduledPhoneCall,
      });
    },
    async updatePassword(params: { previousPassword: string; newPassword: string }) {
      return coreAPI.authCall({
        method: "POST",
        endpoint: "/userDetails/changePassword",
        body: {
          previousPassword: params.previousPassword,
          proposedPassword: params.newPassword,
        },
      });
    },

    async resendVerificationEmail(email: string) {
      return coreAPI.authCall({
        method: "POST",
        endpoint: "/sendEmailVerification",
        body: {
          email,
        },
      });
    },

    async getStatesList() {
      return coreAPI.authCall<StaticDataList>({
        method: "GET",
        endpoint: "/userDetails/states",
      });
    },

    async schedulePhoneCall(eventUri: string) {
      return await coreAPI.authCall<ScheduledPhoneCall>({
        method: "POST",
        endpoint: "/tenant/schedulePhoneCall",
        body: {
          eventUrl: eventUri,
        },
      });
    },

    async getScheduleCallDetails() {
      try {
        return await coreAPI.authCall<ScheduledPhoneCall>({
          method: "GET",
          endpoint: "/tenant/schedulePhoneCall",
        });
      } catch {
        return null;
      }
    },
  };
}
